/**
 * The "try the new version" button on the v1 Manager Review page. Rendered next to v1 by the
 * route (PeopleSpace.tsx), so the v1 view itself stays untouched. Only pilot testers see it.
 */
import { useNavigate } from 'react-router-dom';
import { Button } from '@finn-auto/design-system/atoms/button';
import { useManagerReviewV2Access } from './useManagerReviewV2Access';

export default function ManagerReviewV2Entry() {
  const { enabled, live } = useManagerReviewV2Access();
  const navigate = useNavigate();
  if (!enabled || live) return null;
  return (
    <div className="fixed bottom-6 right-6 z-50">
      <Button type="button" variant="primary" onClick={() => navigate('/manager-review/v2')}>
        Try the new version
      </Button>
    </div>
  );
}
